import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './noData.module.scss';

const TenantNotFound = () => (
  <div className={styles.forbidden} style={{ margin: 'auto', width: '1400px' }}>
    <FormattedMessage
      id="tenant.no_tenant_found"
      defaultText="The system could not detect your login account with the associated Tenant to your profile.
       Please try and login with your phone number. If unsuccessful please contact your permit administrator or Airport Staff."
    />
  </div>
);

export default TenantNotFound;
